import { Component, EventEmitter, Injectable, OnInit, Output } from '@angular/core';
import { Utente } from '../../../class/userinterface';
import { Utenteservice } from '../../../services/utente.service';
@Injectable({
  providedIn: "root"
})
@Component({
  selector: 'app-nica-licenza-info',
  templateUrl: './nica-licenza-info.component.html',
  styleUrls: ['./nica-licenza-info.component.css']
})
export class NicaLicenzaInfoComponent implements OnInit {

  @Output() emettiChiusura = new EventEmitter<any>();
  utenteAttuale?:Utente;

  constructor(private utenteService:Utenteservice) {
    this.utenteAttuale= this.utenteService.InfoUtenteConnesso;
  }



  ngOnInit() {

    this.utenteService.changedUser.subscribe(
      (utente:Utente)=>{
        this.utenteAttuale=utente;
        console.trace(this.utenteAttuale);
        console.trace(this.utenteService.InfoUtenteConnesso);

        
      }
    )
  }

  
  emettiChiusuraDiQuestoComponente(){

    let exit={
      name:'close'
    }
    this.emettiChiusura.emit(exit);

  }

}
